export const rubros = [
		{
			
			"nombre": "1.Normatividad",
			"icono": "Normatividad.png",
			"formatos": [
				{
					"nombre": "Marco Normativo",
					"xlsx": "f01",
					"html": "f01"
				}
			]
		}, 
		{
			
			"nombre": "2.Estructura",
			"icono":"Estructura.png",
			"formatos": [
				{
					"nombre": "Estructura Orgánica",
					"xlsx": "f02_a",
					"html": "f02_a"
				},
				{
					"nombre": "Organigrama",
					"xlsx": "f02_b",
					"html": "f02_b"
				}
			]
		},
		{
			
			"nombre": "3.Facultades",
			"icono":"Facultades.png",
			"formatos": [
				{
					"nombre": "Facultades",
					"xlsx": "f03",
					"html": "f03"
				}
			]
		},
		{
			
			"nombre": "4.Programas Operativos Anuales",
			"icono":"ProgramasOperativosAnuales.png",
			"formatos": [
				{
					"nombre": "Metas y Objetivos",
					"xlsx": "f04",
					"html": "f04"
				}
			]
			
		},
		{
			
			"nombre": "5.Indicadores de Interés",
			"icono":"IndicadoresInteres.png",
			"formatos": [
				{
					"nombre": "Indicadores de Interés",
					"xlsx": "f05",
					"html": "f05"
				}
			]
			
		},
		{
			
			"nombre": "6.Matriz de Indicadores",
			"icono":"MatrizIndicadores.png",
			"formatos": [
				{
					"nombre": "Matriz de Indicadores",
					"xlsx": "f06",
					"html": "f06"
				}
			]
			
		},
		{
			
			"nombre": "7.Directorio",
			"icono":"Directorio.png",
			"formatos": [
				{
					"nombre": "Directorio",
					"xlsx": "f07",
					"html": "f07"
				}
			]
			
		},
		{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/8.%20Sueldos",
		//"url":"Transparencia.html?ver=Sueldos",
	    "icono":"Sueldos.png",
	    "nombre":"8.Sueldos",
	    "formatos":[
	    	{
	    		"nombre":"Remuneraciones",
	    		"xlsx":"",
	    		"html":"",
	    	}
			]
			
		},
		{
			
			"nombre": "9.Viáticos",
			"icono":"Viaticos.png",
			"formatos": [
				{
					"nombre": "Viáticos",
					"xlsx": "f09",
					"html": "f09"
				}
			]	
		},
		{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/10.%20Plazas",
		//"url":"Transparencia.html?ver=Plazas",
	    "icono":"Plazas.png",
	    "nombre":"10.Plazas",
	    "formatos":[
	    	{
	    		"nombre":"Total de Personal de Base y Confianza",
	    		"xlsx":"",
	    		"html":"",
	    	},
	    	{
	    		"nombre":"Total de las Plazas de Base y Confianza",
	    		"xlsx":"",
	    		"html":"",
	    	}
			]	
		},
		{
			
			"nombre": "11.Honorarios",
			"icono":"Honorarios.png",
			"formatos": [
				{
					"nombre": "Personal de Honorarios",
					"xlsx": "f11",
					"html": "f11"
				}
			]	
		},
		{
			"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/12.%20Declaraciones%20P%C3%BAblicas",
		//"url":"Transparencia.html?ver=Declaraciones_Publicas",
	    "icono":"DeclaracionesPublicas.png",
	    "nombre":"12.Declaraciones Públicas",
	    "formatos":[
	    	{
	    		"nombre":"Declaraciones Patrimoniales",
	    		"xlsx":"https://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f12_SC.xlsx",
	    		"html":"https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f12_SC.htm",
	    	}
			]	
		},
		{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/13.%20Datos%20de%20Contacto%20de%20la%20Unidad",
		//"url":"Transparencia.html?ver=Datos_de_Contacto_de_la_Unidad",
	    "icono":"DatosContactoUnidad.png",
	    "nombre":"13.Datos de contacto de la Unidad",
	    "formatos":[
	    	{
	    		"nombre":"Domicilio de la Unidad de Transparencia",
	    		"xlsx":"",
	    		"html":"",
	    	}
			]
		},
		{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/14.%20Convocatorias",
		//"url":"Transparencia.html?ver=Convocatorias",
	    "icono":"Convocatorias.png",
	    "nombre":"14.Convocatorias",
	    "formatos":[
	    	{
	    		"nombre":"Convocatorias a Concursos para Cargos Públicos",
	    		"xlsx":"",
	    		"html":"",
	    	}
			]
		},
		{
		"url":"https://sebiso.hidalgo.gob.mx/transparencia/Rubros/DetalleRubro/15%20-%20Programas%20Sociales",
	    "icono":"ProgramasSociales.png",
	    "nombre":"15.Programas Sociales",
	    "formatos":[
	    	{
	    		"nombre":"Programas de Subsidio, Estímulo y Apoyo",
	    		"xlsx":"https://sedeco.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f15_a%20SEDECO.xlsx",
	    		"html":"https://sedeco.hidalgo.gob.mx/transparencia/htm/a69_f15_a%20SEDECO.htm",
	    	},
	    	{
	    		"nombre":"Padrón de beneficiarios",
	    		"xlsx":"https://sedeco.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f15_b%20SEDECO.xlsx",
	    		"html":"https://sedeco.hidalgo.gob.mx/transparencia/htm/a69_f15_b%20SEDECO.htm",
	    	}
			]
		},
		{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/16.%20Relaciones%20Laborales",
		//"url":"Transparencia.html?ver=Relaciones_Laborales",
	    "icono":"RelacionesLaborales.png",
	    "nombre":"16.Relaciones Laborales",
	    "formatos":[
	    	{
	    		"nombre":"Condiciones Generales de Trabajo",
	    		"xlsx":"https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f16_aOM.xlsx",
	    		"html":"https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f16_aOM.htm",
	    	},
	    	{
	    		"nombre":"Recursos Públicos",
	    		"xlsx":"https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f16_bOM.xlsx",
	    		"html":"https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f16_bOM.htm",
	    	}
			]
		},
		{
			
			"nombre": "17.Información Curricular",
			"icono":"InformacionCurricular.png",
			"formatos": [
				{
					"nombre": "Información Curricular",
					"xlsx": "f17",
					"html": "f17"
				}
			]
		},
		{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/18.%20Sanciones%20Administrativas",
		//"url":"Transparencia.html?ver=Sanciones_Administrativas",
	    "icono":"SancionesAdministrativas.png",
	    "nombre":"18.Sanciones Administrativas",
	    "formatos":[
	    	{
	    		"nombre":"Servidores Publicos Sancionados",
	    		"xlsx":"https://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f18_SC.xlsx",
	    		"html":"https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f18_SC.htm",
	    	}
			]	
		},
		{
			
			"nombre": "19.Servicios",
			"icono":"Servicios.png",
			"formatos": [
				{
					"nombre": "Servicios",
					"xlsx": "f19",
					"html": "f19"
				}
			]
			
		},
		{
			
			"nombre": "20.Trámites",
			"icono":"Tramites.png",
			"formatos": [
				{
					"nombre": "Trámites",
					"xlsx": "f20",
					"html": "f20"
				}
			]
			
		},
		{
		"url":"https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/21.Presupuesto%20e%20Informes%20Trimestrales",
		//"url":"Transparencia.html?ver=Presupuesto_e_Informes_Semestrales",
	    "icono":"PresupuestoInformesTrimestrales.png",
	    "nombre":"21.Presupuesto e Informes Trimestrales",
	    "formatos":[
	    	{
	    		"nombre":"Presupuesto Anual",
	    		"xlsx":"https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f21_aSFP.xlsx",
	    		"html":"https://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f21_aSFP.htm",
	    	},
	    	{
	    		"nombre":"Gasto trimestral",
	    		"xlsx":"https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f21_bSFP.xlsx",
	    		"html":"https://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f21_bSFP.htm",
	    	},
	    	{
	    		"nombre":"Cuenta Pública",
	    		"xlsx":"https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f21_cSFP.xlsx",
	    		"html":"https://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f21_cSFP.htm",
	    	}
			]
			
		},
		{
		"url":"https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/22.Deuda%20P%C3%BAblica",
		//"url":"Transparencia.html?ver=Deuda_Publica",
	    "icono":"DeudaPublica.png",
	    "nombre":"22.Deuda Pública",
	    "formatos":[
	    	{
	    		"nombre":"Deuda Pública",
	    		"xlsx":"https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f22SFP.xlsx",
	    		"html":"https://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f22SFP.htm",
	    	}
			]
		},
		{
			
			"nombre": "23.Comunicación Social y Publicidad",
			"icono":"ComunicacionSocialPublicidad.png",
			"formatos": [
				{
					"nombre": "Programa Anual de Comunicación Social",
					"xlsx": "f23_a",
					"html": "f23_a"
				},
				{
					"nombre": "Erogación de Recursos de Comunicación Social",
					"xlsx": "f23_b",
					"html": "f23_b"
				},
				{
					"nombre": "Tiempos Oficiales",
					"xlsx_liga": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.xlsx",
					"html_liga": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/RadioTVH/dir1/FC/a69_f23_c_RTH.htm"
				},

			]
		},
		{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/24.%20Resultados%20de%20Auditor%C3%ADas",
		//"url":"Transparencia.html?ver=Resultados_de_Auditorias",
	    "icono":"ResultadosAuditorias.png",
	    "nombre":"24.Resultados de Auditorías",
	    "formatos":[
	    	{
	    		"nombre":"Auditorías",
	    		"xlsx":"https://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f24_SC.xlsx",
	    		"html":"https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f24_SC.htm",
	    	}
			]
		},
		{
		"url":"https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/25.Dict%C3%A1menes%20de%20Estados%20Financieros",
		//"url":"Transparencia.html?ver=Dictamenes_de_Estados_Financieros",
	    "icono":"DictamenesFinancieros.png",
	    "nombre":"25.Dictámenes de Estados Financieros",
	    "formatos":[
	    	{
	    		"nombre":"Estados Financieros",
	    		"xlsx":"https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f25SFP.xlsx",
	    		"html":"https://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f25SFP.htm",
	    	}
			]
			
		},
		{
		"url":"https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/26.Asignacion%20de%20Recursos%20Publicos%20a%20Personas",
	    "icono":"AsignacionRecursosPublicosPersonas.png",
	    "nombre":"26.Asignacion de Recursos Publicos a Personas",
	    "formatos":[
	    	{
	    		"nombre":"Personas a Quienes se asignó Recursos Públicos",
	    		"xlsx":"https://sedeco.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f26%20SEDECO.xlsx",
	    		"html":"https://sedeco.hidalgo.gob.mx/transparencia/htm/a69_f26%20SEDECO.htm",
	    	}
			]
			
		},
		{
			
			"nombre": "27.Concesiones",
			"icono":"Concesiones.png",
			"formatos": [
				{
					"nombre": "Concesiones, Contratos, Convenios, Permisos, Licencias y Autorizaciones",
					"xlsx": "f27",
					"html": "f27"
				}
			]
			
		},
		{
		//"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/28.%20Licitaciones%20P%C3%BAblicas",
	    "icono":"LicitacionesPublicas.png",
	    "nombre":"28.Licitaciones Públicas",
	    "formatos":[
	    	{
	    		"nombre":"Procedimientos de Adjudicación Directa, Licitación Pública e Invitación Restringida",
	    		"xlsx":"f28",
	    		"html":"f28",
	    	},
	    	
			]
			
		},
		{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/29.%20Informes",
		//"url":"Transparencia.html?ver=Informes",
	    "icono":"Informes.png",
	    "nombre":"29.Informes",
	    "formatos":[
	    	{
	    		"nombre":"Informes",
	    		"xlsx":"https://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f29_SC.xlsx",
	    		"html":"https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f29_SC.htm",
	    	}
			]
			
		},
		{
			
			"nombre": "30.Estadísticas Generadas",
			"icono":"EstadisticasGenerales.png",
			"formatos": [
				{
					"nombre": "Estadísticas",
					"xlsx": "f30",
					"html": "f30"
				}
			]
			
		},
		{
		"url":"https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/31.Informe%20de%20Avances%20y%20Documentos%20Financieros",
		//"url":"Transparencia.html?ver=Informe_de_Avances_y_Documentos_Financieros",
	    "icono":"InformeAvancesDocumentosFinancieros.png",
	    "nombre":"31.Informe de Avances y Documentos Financieros",
	    "formatos":[
	    	{
	    		"nombre":"Informe de Estados Financieros",
	    		"xlsx":"https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f31_aSFP.xlsx",
	    		"html":"https://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f31_aSFP.htm",
	    	},
	    	{
	    		"nombre":"Informe Contable, Presupuestal y Programático",
	    		"xlsx":"https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f31_bSFP.xlsx",
	    		"html":"https://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f31_bSFP.htm",
	    	}
			]
			
		},
		{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/32.%20Padr%C3%B3n%20de%20Proveedores%20y%20Contratistas",
		//"url":"Transparencia.html?ver=Padron_de_Proveedores_y_Contratistas",
	    "icono":"PadronProveedoresContratistas.png",
	    "nombre":"32.Padrón de Proveedores y Contratistas",
	    "formatos":[
	    	{
	    		"nombre":"Padrón de Proveedores y Contratistas",
	    		"xlsx":"https://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f32_SC.xlsx",
	    		"html":"https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f32_SC.htm",
	    	}
			]
			
		},
		{
			
			"nombre": "33.Convenios con Sectores Social y Privado",
			"icono":"ConveniosSectoresSocialPrivado.png",
			"formatos": [
				{
					"nombre": "Convenios de Coordinación y Concertación",
					"xlsx": "f33",
					"html": "f33"
				}
			]
			
		},
		{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/34.%20Inventario%20de%20Bienes",
		//"url":"Transparencia.html?ver=Inventario_de_Bienes",
	    "icono":"InventarioBienes.png",
	    "nombre":"34.Inventario de Bienes",
	    "formatos":[
	    	{
	    		"nombre":"Inventario de Bienes Muebles",
	    		"xlsx":"https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_aOM.xlsx",
	    		"html":"https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f34_aOM.htm",
	    	},
	    	{
	    		"nombre":"Alta de Bienes Muebles",
	    		"xlsx":"https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_bOM.xlsx",
	    		"html":"https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f34_bOM.htm",
	    	},
	    	{
	    		"nombre":"Bajas de Bienes Muebles",
	    		"xlsx":"https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_cOM.xlsx",
	    		"html":"https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f34_cOM.htm",
	    	},
	    	{
	    		"nombre":"Inventario de Bienes Inmuebles",
	    		"xlsx":"https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_dOM.xlsx",
	    		"html":"https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f34_dOM.htm",
	    	},
	    	{
	    		"nombre":"Alta de Bienes Inmuebles",
	    		"xlsx":"https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_eOM.xlsx",
	    		"html":"https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/222/a69_f34_eOM.htm",
	    	},
	    	{
	    		"nombre":"Bajas de Bienes Inmuebles",
	    		"xlsx":"https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_fOM.xlsx",
	    		"html":"https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f34_fOM.htm",
	    	},
	    	{
	    		"nombre":"Donaciones de Bienes Muebles e Inmuebles",
	    		"xlsx":"https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f34_gOM.xlsx",
	    		"html":"https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f34_gOM.htm",
	    	}

			]
			
		},
		{
			
			"nombre": "35.Recomendaciones y Atención en Materia de Derechos Humanos",
			"icono":"RecomendacionesAtenciónMateriaDerechosHumanos.png",
			"formatos": [
				{
					"nombre": "Recomendaciones de Derechos Humanos Emitidas por la CNDH",
					"xlsx": "f35_a",
					"html": "f35_a"
				},
				{
					"nombre": "Recomendaciones de Derechos Humanos Casos Especiales",
					"xlsx": "f35_b",
					"html": "f35_b"
				},
				{
					"nombre": "Las Recomendaciones de Derechos Humanos Org. Int. CNDH",
					"xlsx": "f35_c",
					"html": "f35_c"
				},
			]
			
		},
		{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/36.%20Resoluciones%20y%20Laudos%20de%20Juicios",
		//"url":"Transparencia.html?ver=Resoluciones_y_Laudos_de_Juicios",
	    "icono":"ResolucionesLaudosJuicios.png",
	    "nombre":"36.Resoluciones y Laudos de Juicios",
	    "formatos":[
	    	{
	    		"nombre":"Resoluciones y Laudos",
	    		"xlsx":"https://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f36_SC.xlsx",
	    		"html":"https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f36_SC.htm",
	    	}
			]
			
		},
		{
			
			"nombre": "37.Mecanismo de Participación Ciudadana",
			"icono":"MecanismosParticipacionCiudadana.png",
			"formatos": [
				{
					"nombre": "Mecanismos de Participación Ciudadana",
					"xlsx": "f37_a",
					"html": "f37_a"
				},
				{
					"nombre": "Resultados de los Mecanismos de Participación Ciudadana",
					"xlsx": "f37_b",
					"html": "f37_b"
				}
			]
			
		},
		{
			
			"nombre": "38.Programas Ofrecidos",
			"icono":"ProgramasOfrecidos.png",
			"formatos": [
				{
					"nombre": "Programas que Ofrecen",
					"xlsx": "f38_a",
					"html": "f38_a"
				},
				{
					"nombre": "Tramites a los Programas que Ofrecen",
					"xlsx": "f38_b",
					"html": "f38_b"
				}
			]
			
		},
		{
		"url":"https://s-contraloria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/39.%20Actas%20y%20Resoluciones%20del%20Comit%C3%A9%20de%20Transparencia",
		//"url":"Transparencia.html?ver=/Actas_y_Resoluciones_del_Comite_de_Transparencia",
	    "icono":"ActasResolucionesComiteTransparencia.png",
	    "nombre":"39.Actas y Resoluciones del Comité de Transparencia",
	    "formatos":[
	    	{
	    		"nombre":"Informe de Sesiones",
	    		"xlsx":"https://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f39a_SC.xlsx",
	    		"html":"https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f39a_SC.htm",
	    	},
	    	{
	    		"nombre":"Informe de Resoluciones",
	    		"xlsx":"https://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f39b_SC.xlsx",
	    		"html":"https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f39b_SC.htm",
	    	},
	    	{
	    		"nombre":"Actas Integrantes del Comité",
	    		"xlsx":"https://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f39c_SC.xlsx",
	    		"html":"https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f39c_SC.htm",
	    	},
	    	{
	    		"nombre":"Calendario de Sesiones del comité",
	    		"xlsx":"https://s-contraloria.hidalgo.gob.mx/transparencia/xls/2018/a69_f39d_SC.xlsx",
	    		"html":"https://s-contraloria.hidalgo.gob.mx/transparencia/htm/a69_f39d_SC.htm",
	    	}
			]
			
		},
		{
			
			"nombre": "40.Evaluacion y Encuesta a Programas Financiados con Recursos Públicos",
			"icono":"EvaluacionencuestasProgramas.png",
			"formatos": [
				{
					"nombre": "Evaluaciones",
					"xlsx": "f40",
					"html": "f40"
				}
			]	
			
		},
		{
			
			"nombre": "41.Estudios Pagados con Recursos Públcos",
			"icono":"EstudiosPagadosRecursosPublicos.png",
			"formatos": [
				{
					"nombre": "Estudios Pagados con Recursos Públicos ",
					"xlsx": "f41",
					"html": "f41"
				}
			]
			
		},
		{
		"url":"https://oficialiamayor.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/42.%20Listados%20Jubilados%20y%20Pensionados",
		//"url":"Transparencia.html?ver=Listado_de_Jublidados_y_Pensionados",
	    "icono":"ListadoJubiladosPencionados.png",
	    "nombre":"42.Listado de Jubilados y Pensionados",
	    "formatos":[
	    	{
	    		"nombre":"Jubilados y Pensionados Leyenda",
	    		"xlsx":"https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f42_aOM.xlsx",
	    		"html":"https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f42_aOM.htm",
	    	},
	    	{
	    		"nombre":"Jubilados y Pensionados Listado",
	    		"xlsx":"https://oficialiamayor.hidalgo.gob.mx/transparencia/xlsx/2022/a69_f42_bOM.xlsx",
	    		"html":"https://oficialiamayor.hidalgo.gob.mx/transparencia/htm/2022/a69_f42_bOM.htm",
	    	}
			]	
			
		},
		{
		"url":"https://hacienda.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/43.Ingresos%20Recibidos%20por%20Cualquier%20Concepto",
		//"url":"Transparencia.html?ver=Ingresos_Recibidos_por_Cualquier_Concepto",
	    "icono":"IngresosRecibidosCualquierConcepto.png",
	    "nombre":"43.Ingresos Recibidos por Cualquier Concepto",
	    "formatos":[
	    	{
	    		"nombre":"Ingresos Recibidos",
	    		"xlsx":"https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f43_aSFP.xlsx",
	    		"html":"https://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f43_aSFP.htm",
	    	},
	    	{
	    		"nombre":"Responsables de Recibir los Ingresos",
	    		"xlsx":"https://s-finanzas.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f43_bSFP.xlsx",
	    		"html":"https://s-finanzas.hidalgo.gob.mx/transparencia/htm/a69_f43_bSFP.htm",
	    	}
			]	
			
		},
		{
			
			"nombre": "44.Donaciones Hechas a Terceros",
			"icono":"DonacionesHechasTerceros.png",
			"formatos": [
				{
					"nombre": "Donaciones hechas a Terceros en Dinero y en especie",
					"xlsx": "f44",
					"html": "f44"
				}
			]	
			
		},
		{
			
			"nombre": "45.Catálogo Documental y Guia de Archivos",
			"icono":"Viaticos.png",
			"formatos": [
				{
					"nombre": " Inventarios Documentales.",
					"xlsx": "f45_a",
					"html": "f45_a"
				},
				{
					"nombre": "Índice de Expedientes Clasificados.",
					"xlsx_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/xlsx/a69_f45b_SC.xlsx",
					"html_liga": "https://s-contraloria.hidalgo.gob.mx/Transparencia/htm/a69_f45b_SC.htm"
				},
				{
					"nombre": "Instrumentos Archivísticos.",
					"xlsx": "f45_c",
					"html": "f45_c"
				}
			]
			
		},
		{
			
			"nombre": "46.Actas de Sesiones, Opiniones y Recomendaciones de Consejos Consultivos",
			"icono":"CatalogoDocumentalGuiaArchivos.png",
			"formatos": [
				{
					"nombre": "Actas del Consejo Consultivo Ciudadano",
					"xlsx": "f46_a",
					"html": "f46_a"
				},
				{
					"nombre": "Opiniones del Consejo Consultivo Ciudadano",
					"xlsx": "f46_b",
					"html": "f46_b"
				}
			]	
			
		},
		{
		"url":"https://procuraduria.hidalgo.gob.mx/Transparencia/Rubros/DetalleRubro/Solicitud%20de%20Intervenci%C3%B3n%20de%20%20Comunicaciones",
		//"url":"Transparencia.html?ver=Solicitud_de_Intervencion_de_Comunicaciones",
	    "icono":"SolicitudIntervencionComunicaciones.png",
	    "nombre":"47.Solicitud de Intervencion de Comunicaciones",
	    "formatos":[
	    	{
	    		"nombre":"Intervenciones de comunicaciones",
	    		"xlsx":"https://procuraduria.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f47_aPGJEH.xlsx",
	    		"html":"https://procuraduria.hidalgo.gob.mx/transparencia/htm/a69_f47_aPGJEH.htm",
	    	},
	    	{
	    		"nombre":"Localización Geográfica",
	    		"xlsx":"https://procuraduria.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f47_bPGJEH.xlsx",
	    		"html":"https://procuraduria.hidalgo.gob.mx/transparencia/htm/a69_f47_bPGJEH.htm",
	    	},
	    	{
	    		"nombre":"Mensaje de Solicitudes a empresas para la intervención de comunicaciones privadas",
	    		"xlsx":"https://procuraduria.hidalgo.gob.mx/transparencia/xlsx/2020/a69_f47_cPGJEH.xlsx",
	    		"html":"https://procuraduria.hidalgo.gob.mx/transparencia/htm/a69_f47_cPGJEH.htm",
	    	}
			]
			
		},
		{
			
			"nombre": "48.Información de Utilidad o Relevante",
			"icono":"InformacionUtilidadRelevante.png",
			"formatos": [
				{
					"nombre": "Interés Público",
					"xlsx": "f48_a",
					"html": "f48_a"
				},
				{
					"nombre": "Preguntas Frecuentes",
					"xlsx": "f48_b",
					"html": "f48_b"
				},
				{
					"nombre": "Transparencia Proactiva",
					"xlsx": "f48_c",
					"html": "f48_c"
				}
			]

			
		},
]